import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import { SPassengersSelection, SConstants } from '@slg/web-customer-shared';
import importedAppConfig from '@/appConfig';
import { useStore } from '@/composables';


const __default__ = {
  name: 'PassengersSelection',
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ['clearBookingRequestError'],
  setup(__props, { emit }) {


const store = useStore();
const appConfig = ref<Record<string, any>>({});
const show = ref(false);
appConfig.value = importedAppConfig;

const getAdults = computed(() => store.getters['booking/getAdults']);
const getChildren = computed(() => store.getters['booking/getChildren']);
const getVehicleCategoryId = computed(() => store.getters['booking/getVehicleCategoryId']);
const getVehicleCategories = computed(() => store.getters['opsZone/getVehicleCategories']);
const getSelectedFeatures = computed(() => store.getters['booking/getSelectedFeatures']);
const getWheelchairPlacesAmount = computed(() => {
  const wheelChairFeature = getSelectedFeatures.value?.find(
    (feature: { vehicleFeatureId: string }) => feature.vehicleFeatureId === SConstants.WHEELCHAIR_PLACE_ID,
  );
  return wheelChairFeature?.amount;
});

function updateAdults(newValue: number) {
  store.commit('booking/setAdults', newValue);
  emit('clearBookingRequestError');
}

function updateChildren(newValue: number) {
  emit('clearBookingRequestError');
  store.commit('booking/setChildren', newValue);
}

return { __sfc: true,emit, store, appConfig, show, getAdults, getChildren, getVehicleCategoryId, getVehicleCategories, getSelectedFeatures, getWheelchairPlacesAmount, updateAdults, updateChildren, SPassengersSelection }
}

})